export default __webpack_public_path__ + "static/media/monkey.c451c522.png";